import { NumberShim } from '@packages/helpers/core/shims/number-shim';

export const mapSimulatedMyPlanChartConfig = goals => {
  if (goals) {
    const depositSavings = goals.depositSavings + Math.round(goals.totalCosts / 4) + 1;
    const monthlySaving = goals.monthlySaving + Math.round(goals.savePerMonth / 4) + 1;

    return {
      ...goals,
      depositSavings,
      monthlySaving,
      inTotalLowerValue: goals.totalCosts - depositSavings,
      eachMonthLowerValue: goals.savePerMonth - monthlySaving
    };
  } else {
    const totalCosts = NumberShim.random(250000, 500000);
    const savePerMonth = NumberShim.random(500, 1500);

    return {
      timeframe: NumberShim.random(10, 25),
      depositSavings: 0,
      monthlySaving: 0,
      totalCosts,
      savePerMonth,
      inTotalLowerValue: totalCosts,
      eachMonthLowerValue: savePerMonth
    };
  }
};
